import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SignInSqureLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M7 7.132v-.52c0-2.146 0-3.219.69-3.817s1.751-.446 3.876-.143l4.282.612c2.457.351 3.685.526 4.418 1.372S21 6.723 21 9.204v5.592c0 2.481 0 3.722-.734 4.568-.733.846-1.961 1.021-4.417 1.372l-4.283.612c-2.125.303-3.187.455-3.876-.143S7 19.534 7 17.388v-.322" }),
            React.createElement("path", { fill: "currentColor", d: "m16 12 .39-.312.25.312-.25.312zm-12 .5a.5.5 0 0 1 0-1zm8.39-5.812 4 5-.78.624-4-5zm4 5.624-4 5-.78-.624 4-5zM16 12.5H4v-1h12z" })));
}
const SignInSqureLight = forwardRef(_SignInSqureLight);
export { SignInSqureLight };
